import { render, staticRenderFns } from "./PartnerDropdown.vue?vue&type=template&id=10fa5676&scoped=true&"
import script from "./PartnerDropdown.vue?vue&type=script&lang=js&"
export * from "./PartnerDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDropdown.vue?vue&type=style&index=0&id=10fa5676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa5676",
  null
  
)

export default component.exports